'use strict'

/**
 * Module ajout au panier
 */
import { UpdateMiniPanier } from 'Modules/miniPanier'
import responsive from 'Helpers/responsive'

const J_BUTTON = '.j_addToBarket_addToBarketVerification'
const J_BUTTON2 = '.j_addToBasket_addToBasketVerification'

const J_BUTTON_WISH = '.btnAddToWish'
const J_SELECTED_LIST = '.j_alerte_showAlerte'
const J_TAILLE_DISPO = 'j_tDispo_showAlerte'
const J_POPUP_PANIER = '.j_modal_panier'
const J_ADD_PANIER_FORM = '.j_addPanierForm'
const J_NEED_POPUP_DATA = 'needpanierpopup'
const C_HIDDEN = 'hidden'
const J_ERROR_MESSAGE = '.j_error_addToBarketVerification'
const J_RM = '.j_rm_showAlerte'
const J_CC = '.j_cc_showAlerte'
const URL_ADD_PANIERAPI = '/Produit/MisePanierArticle'

let isAjouterPanierEnCour = false
let touchstartOrMouseenter = responsive.isMobile() ? 'touchstart' : 'mouseenter'

function init() {
    if ($(J_ADD_PANIER_FORM).data(J_NEED_POPUP_DATA) === 'True') {
        $(J_POPUP_PANIER).modal({
            keyboard: true,
            show: true
        })
    }
    $(J_BUTTON).removeAttr('disabled') // on enlève le disabled qui été ajouté pour gérer les cliques avant que le js soit dispo
    $(J_BUTTON2).removeAttr('disabled') // on enlève le disabled qui été ajouté pour gérer les cliques avant que le js soit dispo
}

/*
 * Initliase l'event over sur le bouton
 */
function setEvent() {
    $(J_BUTTON).on('click', function () {
        // Gestion de l'affichage du message d'erreur

        if (!$(J_SELECTED_LIST + ' option:selected').hasClass(J_TAILLE_DISPO)) {
            $(J_ERROR_MESSAGE).removeClass(C_HIDDEN)
            // Affiche la liste des tailles si pas de tailles présélectionnées
            if (
                $('.mob .container-selectedtaille span').attr('id') ===
                'libtaillesdispos'
            ) {
                $('.j_box_tailles').addClass('active')
                $('.choix-taillesmob').addClass('autobasket')
            } else if (
                $('.j_choix_tailles span').attr('id') === 'libtaillesdispos'
            ) {
                $('.j_box_tailles').addClass('active')
                $('.choix-tailles').addClass('autobasket')
            }
            return false
        } else {
            const libelleTaille = $(
                '.j_alerte_showAlerte option:selected'
            ).data('libelle')

            if (isAjouterPanierEnCour === false) {
                isAjouterPanierEnCour = true
                // Envoi de la mise au panier en AJAX
                $.ajax({
                    url: URL_ADD_PANIERAPI,
                    type: 'PUT',
                    data: {
                        refModele: $(J_RM).val(),
                        codeCouleur: $(J_CC).val(),
                        codeTaille: $(
                            '.j_alerte_showAlerte option:selected'
                        ).val()
                    },
                    success: function (data) {
                        $('.productListTailles').html(data.view)
                        // eslint-disable-next-line no-eval
                        eval(data.script)
                        if (data.resultat == 'OK') {
                            if ($('.numb-prod').find('strong').length == 0) {
                                $('.numb-prod').append(
                                    '<strong class="basket-count">1</strong>'
                                )
                            } else {
                                $('.basket-count').html(
                                    parseInt($('.basket-count').html()) + 1
                                )
                            }
                        } else {
                            $('.j_modal_unavailable').modal('show')
                        }

                        isAjouterPanierEnCour = false

                        if (data.resultat == 'OK') {
                            UpdateMiniPanier()
                            $('#j_modalConfirmationContent').html(data.modal)
                            $('#modal-panier').modal('show')
                            $('.taille-selected').append(libelleTaille)
                        }

                        setEvent()
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        $('.j_modal_unavailable').modal('show')
                        isAjouterPanierEnCour = false
                    }
                })
            }
            return true
        }
    })

    // Si on a pas de tailles, on affiche l'erreur et bloque le bouton
    $(J_BUTTON).on(touchstartOrMouseenter, function () {
        if (!$(J_SELECTED_LIST + ' option:selected').hasClass(J_TAILLE_DISPO)) {
            $(this).empty().append($t('DOIT_SELECTIONNER_TAILLE'))
        }
    })

    // Quand on leave le bouton, on enlère l'erreur et on remet en place le bouton + svg
    $(J_BUTTON).on('mouseleave', function () {
        $(this)
            .empty()
            .html(`<span>${$t('AJOUTER_PANIER')}</span>`)
    })

    $(J_BUTTON2).on('click', function () {
        // Gestion de l'affichage du message d'erreur

        if (!$(J_SELECTED_LIST + ' option:selected').hasClass(J_TAILLE_DISPO)) {
            $(J_ERROR_MESSAGE).removeClass(C_HIDDEN)
            // Affiche la liste des tailles si pas de tailles présélectionnées
            if (
                $('.mob .container-selectedtaille span').attr('id') ===
                'libtaillesdispos'
            ) {
                $('.j_box_tailles').addClass('active')
                $('.choix-taillesmob').addClass('autobasket')
            } else if (
                $('.j_choix_tailles span').attr('id') === 'libtaillesdispos'
            ) {
                $('.j_box_tailles').addClass('active')
                $('.choix-tailles').addClass('autobasket')
            }
            return false
        } else {
            const libelleTaille = $(
                '.j_alerte_showAlerte option:selected'
            ).data('libelle')

            if (isAjouterPanierEnCour === false) {
                isAjouterPanierEnCour = true
                // Envoi de la mise au panier en AJAX
                $.ajax({
                    url: URL_ADD_PANIERAPI,
                    type: 'PUT',
                    data: {
                        refModele: $(J_RM).val(),
                        codeCouleur: $(J_CC).val(),
                        codeTaille: $(
                            '.j_alerte_showAlerte option:selected'
                        ).val()
                    },
                    success: function (data) {
                        $('.productListTailles').html(data.view)
                        // eslint-disable-next-line no-eval
                        eval(data.script)
                        if (data.resultat == 'OK') {
                            if ($('.numb-prod').find('strong').length == 0) {
                                $('.numb-prod').append(
                                    '<strong class="basket-count">1</strong>'
                                )
                            } else {
                                $('.basket-count').html(
                                    parseInt($('.basket-count').html()) + 1
                                )
                            }
                        }
                        document
                            .getElementById('j_notification')
                            .classList.add('do-show')
                        window.setTimeout(function () {
                            document
                                .getElementById('j_notification')
                                .classList.add('do-hide')
                        }, 4000)
                        window.setTimeout(function () {
                            document
                                .getElementById('j_notification')
                                .classList.remove('do-show')
                            document
                                .getElementById('j_notification')
                                .classList.remove('do-hide')
                        }, 5000)
                        if ($('.j_alerte_showAlerte option').length < 2) {
                            $('.j_choix_tailles').hide()
                        }

                        isAjouterPanierEnCour = false

                        if (
                            data.nbProduitsPanier == 1 &&
                            data.resultat == 'OK'
                        ) {
                            UpdateMiniPanier()
                        } else {
                            UpdateMiniPanier()
                            //$('#j_modalConfirmationContent').html(data.modal)
                            $('.taille-selected').append(libelleTaille)
                        }

                        setEvent()
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        $('.j_modal_unavailable').modal('show')
                        isAjouterPanierEnCour = false
                    }
                })
            }
            return true
        }
    })
    // Si on a pas de tailles, on affiche l'erreur et bloque le bouton
    $(J_BUTTON2).on('mouseenter', function () {
        if (!$(J_SELECTED_LIST + ' option:selected').hasClass(J_TAILLE_DISPO)) {
            $(this).empty().append($t('DOIT_SELECTIONNER_TAILLE'))
        }
    })
    // Quand on leave le bouton, on enlère l'erreur et on remet en place le bouton + svg
    $(J_BUTTON2).on('mouseleave', function () {
        $(this)
            .empty()
            .html(
                "<span>Ajouter au Panier</span> <span> <svg width='41px' height='14px' viewBox='0 0 66 43' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <g id='arrow' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'> <path class='one' d='M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z' fill='#FFFFFF'></path> <path class='two' d='M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z' fill='#FFFFFF'></path> <path class='three' d='M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z' fill='#FFFFFF'></path> </g> </svg> </span>"
            )
    })

    $(J_BUTTON_WISH).on('click', function () {
        // Gestion de l'affichage du message d'erreur
        if (!$(J_SELECTED_LIST + ' option:selected').hasClass(J_TAILLE_DISPO)) {
            $(J_ERROR_MESSAGE).removeClass(C_HIDDEN)
            return false
        }
        return true
    })

    // Si on a pas de tailles, on affiche l'erreur et bloque le bouton
    $(J_BUTTON_WISH).on('mouseenter', function () {
        if (!$(J_SELECTED_LIST + ' option:selected').hasClass(J_TAILLE_DISPO)) {
            $(this).empty().append($t('DOIT_SELECTIONNER_TAILLE'))
        }
    })

    // Quand on leave le bouton, on enlère l'erreur et on remet en place le bouton
    $(J_BUTTON_WISH).on('mouseleave', function () {
        $(this).empty().append($t('AJOUTER_AUX_FAVORIS'))
    })

    // Reload la page quand on ferme la popin
    $('.j_modal_panier .close').on('click', function () {
        location.reload()
    })

    $('.j_modal_panier').mouseup(function (e) {
        const container = $('.j_modal_panier .modal-content')

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            location.reload()
        }
    })
}

init()

export default {
    setEvent: setEvent
}
